var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acc-alerts"},[_c('div',{staticClass:"tile-title"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('br'),_vm._t("default"),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }